import { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AppErrorBoundary from '../components/errors/AppErrorBoundary';
import { logRouteMount, logRouteTransition } from './routeDiagnostics';

export function RouteDiagnostics() {
  const location = useLocation();

  useEffect(() => {
    logRouteMount('active', location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    let previous = sessionStorage.getItem('stavyn:last-path') || '';
    if (previous !== location.pathname) {
      logRouteTransition(previous, location.pathname);
      sessionStorage.setItem('stavyn:last-path', location.pathname);
    }
  }, [location.pathname]);

  return null;
}

export function RoutePage({ name, children }) {
  const location = useLocation();

  useEffect(() => {
    logRouteMount(name, location.pathname);
  }, [name, location.pathname]);

  return (
    <AppErrorBoundary context={`route:${name}`} compact showDashboardLink>
      <Suspense fallback={<RouteLoadingState label={name} />}>{children}</Suspense>
    </AppErrorBoundary>
  );
}

function RouteLoadingState({ label }) {
  return (
    <div
      className="flex items-center justify-center py-16 text-sm"
      style={{ color: 'var(--text-muted)' }}
      aria-busy="true"
    >
      Loading {label}…
    </div>
  );
}
